export default __webpack_public_path__ + "static/pool-page-image-2bb62ab66e1e8392fbc7899598d3bae8.png";